var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eno-layout"},[_c('enoHeader'),_c('transition',{attrs:{"name":"el-fade-in"}},[_c('mainPage',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageLoad),expression:"pageLoad"}]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }